import { observer } from 'mobx-react';
import { useEffect } from 'react';
import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useAccount } from 'wagmi';
import folderIcon from '../../../assets/icons/folder.png';
import { useBreakpointContext } from '../../../context-providers/BreakpointProvider';
import { depositWithdrawalStore } from "../../../services/deposit-withdrawal/deposit-withdrawal.store";
import { positionsStore } from '../../../services/position/position.store';
import EmptyStateComponent from '../../EmptyState/EmptyState';

import { getActivityColumns } from '../helpers/activity-columns';
import { getDataGridCommonProps } from '../helpers/data-grid-common-props';
import DepositSmallTableRow from '../small-table-rows/DepositSmallTableRow';

const PAGE_SIZE = 100;
const emptyStateText = 'No deposits';

const UserDeposits = observer(() => {

    const { address } = useAccount();
    const depositColumns = getActivityColumns({ activityType: 'deposit' });
    const { xs } = useBreakpointContext();

    const [paginationEnabled, setPaginationEnabled] = React.useState(positionsStore.openPositionsList.length > PAGE_SIZE);

    useEffect(() => {
        setPaginationEnabled(depositWithdrawalStore.deposits.length > PAGE_SIZE);
    }, [depositWithdrawalStore.deposits.length]);

    useEffect(() => {
        if (address) {
            depositWithdrawalStore.fetchDeposits(address)
        } else {
            depositWithdrawalStore.resetState()
        }
    }, [address])

    return (<div className="TradeTabsNavigation__gridWrapper">
            {xs && depositWithdrawalStore.deposits.length ? depositWithdrawalStore.deposits.map((deposit, index) => {
                return <DepositSmallTableRow key={index} deposit={deposit}/>;
            }) : null}

            {xs && !depositWithdrawalStore.deposits.length ?
                <div className="TradeTabsNavigation__xsEmpty card-container"><EmptyStateComponent text={emptyStateText} icon={<img src={folderIcon} alt={emptyStateText}/>} /></div> : null
            }

            {!xs ?
                <DataGrid
                    {...getDataGridCommonProps(emptyStateText)}
                    rows={depositWithdrawalStore.deposits}
                    columns={depositColumns}
                    hideFooter={!paginationEnabled}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: PAGE_SIZE }
                        },
                        sorting: {
                            sortModel: [{ field: 'date', sort: 'desc' }]
                        }
                    }}
                /> : null
            }
        </div>
    );
});

export default UserDeposits;
